import { EndpointUrl } from 'api/endpoint';
import { useEntityFetcher } from 'api/entity';
import { mutate } from 'swr';

export type FileItem = {
  id: string;
  name: string;
  workspace_id: string;
  created_at: string;
  size: string;
  status: string;
  s3_upload_id: string | null;
  path: string[] | null;
  modified_at: string | null;
  url: string;
};

export function useWorkspaceFiles() {
  return useEntityFetcher<FileItem[]>('files');
}

export async function updateWorkspaceFile(
  workspaceId: string,
  uploadId: string,
  updates: { path?: string[] | null },
) {
  const response = await fetch(
    `${EndpointUrl}/workspace/${workspaceId}/files/${uploadId}`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'x-finsight-token': localStorage.getItem('token') || '',
      },
      body: JSON.stringify(updates),
    },
  );

  if (!response.ok) {
    throw new Error(`Failed to update file: ${response.statusText}`);
  }

  // Invalidate the files cache
  mutate(`${EndpointUrl}/workspace/${workspaceId}/files`);

  return response.json();
}

export async function deleteWorkspaceFile(
  workspaceId: string,
  uploadId: string,
) {
  const response = await fetch(
    `${EndpointUrl}/workspace/${workspaceId}/files/${uploadId}`,
    {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'x-finsight-token': localStorage.getItem('token') || '',
      },
    },
  );

  // Invalidate the files cache
  mutate(`${EndpointUrl}/workspace/${workspaceId}/files`);

  return response;
}
